//
//
//
//

import ArticleSlugWrapper from '~/components/Articles/ArticleSlugWrapper.vue';
import { BLOG_TOPICS } from '~/constants/blogConstants';
export default {
    name: 'GreArticlePage',
    components: { ArticleSlugWrapper },
    provide() {
        return {
            blogTopic: BLOG_TOPICS.GRE
        };
    },
    mounted() {
        this.$store.dispatch('auth/startAcquisitionAuthTimer');
    },
    // eslint-disable-next-line vue/order-in-components
    beforeRouteLeave(to, from, next) {
        // clear the timer if not moving between gre-blogs and gre-blog-slug page
        if (to.name !== 'gre-blogs') {
            this.$store.commit('auth/clearAcquisitionAuthTimer', {
                leavingBlogsPage: true
            });
        }
        next(true);
    }
};
